import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Search = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1394 6.4898C10.1394 8.36193 8.62169 9.87959 6.74956 9.87959C4.87743 9.87959 3.35977 8.36193 3.35977 6.4898C3.35977 4.61766 4.87743 3.1 6.74956 3.1C8.62169 3.1 10.1394 4.61766 10.1394 6.4898ZM9.51165 10.0297C8.74993 10.6249 7.79117 10.9796 6.74956 10.9796C4.26992 10.9796 2.25977 8.96944 2.25977 6.4898C2.25977 4.01015 4.26992 2 6.74956 2C9.22921 2 11.2394 4.01015 11.2394 6.4898C11.2394 7.5314 10.8847 8.49016 10.2895 9.25188L14.0527 13.0152C14.2675 13.23 14.2675 13.5782 14.0527 13.793C13.838 14.0078 13.4897 14.0078 13.2749 13.793L9.51165 10.0297Z"
        fill={color}
      />
    </svg>
  )
})

export default Search
